export const getCookie = (key: string) => {
  const allCookies = document.cookie.split(';');
  let cookieValue;

  allCookies.forEach((cookie) => {
    const [name, value] = cookie.trim().split('=');
    if (name === key) return (cookieValue = value);
  });

  if (!cookieValue) return null;

  return atob(decodeURIComponent(cookieValue));
};

export const setCookie = (
  cookieName: string,
  cookieValue: any,
  expiration?: Date
) => {
  const cookieValueEncoded = cookieValue
    ? btoa(JSON.stringify(cookieValue))
    : '';

  document.cookie = `${cookieName}=${cookieValueEncoded}; path=/; SameSite=None; Secure; expires=${
    expiration?.toUTCString() ?? 0
  }`;
};
